import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ItemStatusService from "../../../Services/ItemStatus.service";
const config = {
    loadOptions: (search, options) => ItemStatusService.getItemStatuses({
        activityItemTypeIds: options.activityItemTypeIds,
        includeNoneStatus: options.includeNoneStatus,
        query: search,
    }).then((response) => response.data),
    value: "id",
    label: "name",
};
export const ItemStatusSearch = makeSearch(config);
export const ItemStatusMultiSearch = makeMultiSearch(config);
